<div class="d-flex h-100 flex-column p-3 bg-body overflow-auto">
  <div class="d-flex align-items-center py-3 ps-3 pe-2 bg-body-secondary rounded-top-5">
    <div class="flex-grow-1">
      <ng-content select="[slot=header]"></ng-content>
    </div>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      [routerLink]="['', { outlets: { popup: null } }]"
    ></button>
  </div>

  <div class="flex-grow-1 overflow-auto h-100">
    <ng-content></ng-content>
  </div>
</div>
